import { mutate } from 'swr';
import apiClient from '../../utils/axiosConfig';
import { useState, useEffect } from 'react';
import { useQuery } from '../../hook/useQuery';


export const useArea = () => {
    const [itemsPerPage, setPerPge] = useState(50)
    const [page, setPage] = useState(1);
    const { filterUrl } = useQuery();
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [allAreas, setAllAreas] = useState([]);
    const [areas, setAreas] = useState([]);
    const [total, setTotal] = useState([]);
    const [lastPage, setLastPage] = useState([]);

    const fetchData = async () => {
        const queryString = filterUrl() || '';
        const url = `/area?perPage=${itemsPerPage}&page=${page}&${queryString}`;
        try {
            const response = await apiClient.get(url);
            await mutate(`/area?perPage=${itemsPerPage}&page=${page}&${queryString}`);
            setData(response?.data);
            setError(null);
        } catch (err) {
            setError(err.response?.data || 'An error occurred');
            setData(null);
        }
    };

    useEffect(() => {
        if (data?.data?.areas?.data) {
            setAreas([...data?.data?.areas?.data]);
            setTotal(data?.data?.areas?.total);
            setLastPage(data?.data?.areas?.last_page);
        }
    }, [data]);

    const fetchAllData = async () => {
        try {
            const response = await apiClient.get('/area')
            setAllAreas(response?.data)
        } catch (error) {

        }
    }

    const create = async (newData) => {
        try {
            const response = await apiClient.post('/area', newData);
            mutate(`/area?perPage=${itemsPerPage}&page=${page}`)
            return response.data
        } catch (err) {
            return err.response.data
        }

    };

    const update = async (id, formData) => {
        try {
            const response = await apiClient.put(`/area/${id}`, formData);
            mutate(`/area?perPage=${itemsPerPage}&page=${page}`)
            mutate(`/area/${id}`)
            return response.data
        } catch (err) {
            return err.response.data
        }
    };

    const deleteArea = async (id) => {
        try {
            const response = await apiClient.delete(`/area/${id}`);
            mutate(`/area?perPage=${itemsPerPage}&page=${page}`)
            return response;
        } catch (err) {
            return err.response.data
        }
    };

    const getById = async (servicePoinTypeId) => {
        const response = await apiClient.get(`/area/${servicePoinTypeId}`);
        return response.data;
    };

    const updateStatus = async (id) => {
        try {
            const response = await apiClient.put(`/area/${id}/status`);
            mutate(`/area?perPage=${itemsPerPage}&page=${page}`);
            return response.data;
        } catch (err) {
            return err.response.data;
        }
    };
    const getAll = async () => {
        try {
            const response = await apiClient.get(`/area`);
            mutate(`/area`);
            return Array.isArray(response?.data?.data?.areas) ? response?.data?.data?.areas : [];
        } catch (err) {
            return err.response.data;
        }
    }
    return {
        allAreas: Array.isArray(allAreas?.data?.areas) ? allAreas?.data?.areas : [],
        areas,
        fetchData,
        fetchAllData,
        isLoading: !error && !data,
        isError: error,
        itemsPerPage,
        lastPage,
        currentPage: page,
        total,
        setPage,
        isLoading: !error && !data,
        create,
        update,
        deleteArea,
        getById,
        mutate,
        updateStatus,
        getAll,
        setPerPge
    };
};
